export const poolFetchOrders = [
  { value: 'latest_trade_timestamp_ms', name: 'Featured' },
  { value: 'created_at', name: 'Creation Time' },
  { value: 'volume_sui', name: 'Trading Volume' },
  { value: 'market_cap_sui', name: 'Market Cap' },
] as const;
